<ngx-otp-input [formControl]="formControl" [config]="otpInputConfig"  (fill)="feedFormControl($event)" *ngIf="otpInputConfig"></ngx-otp-input>